import { tilesConfig as configureTiles } from './TileConfigs/ConfigurePage/tilesConfig';
import { tilesConfig as reportsTiles } from './TileConfigs/ReportsPage/tilesConfig';
import { tilesConfig as incidentManagementTiles } from './TileConfigs/IncidentManagementPage/tilesConfig';
import { tilesConfig as settingsTiles } from './TileConfigs/SettingsPage/tilesConfig';

import { tilesConfig as subscriptionsTiles } from './TileConfigs/SubscriptionsPage/tilesConfig'
import { tilesConfig as riskIntelligenceTiles } from './TileConfigs/RiskIntelligencePage/tilesConfig'
import { tilesConfig as supportTrainingTiles } from './TileConfigs/SupportAndTrainingPage/tilesConfig';
import { subTilesConfig as integrationsSubTiles } from './TileConfigs/IntegrationsPage/subTilesConfig';
import { permissionsConfig } from './TileConfigs/PermissionsPageConfig/PermissionsPageConfig';
import { tilesConfig as brandingTiles } from './TileConfigs/BrandingPage/tilesConfig';
import { tilesConfig as securityTiles } from './TileConfigs/SecurityPage/tilesConfig';
import { alertModuleConfig } from './TileConfigs/AlertModulePage/AlertModulePageConfig';


export const tilesList = {
    ['/incident-management']: incidentManagementTiles.map(({ title, path }) => ({
        title,
        path
    })),
    ['/riskintelligence']: riskIntelligenceTiles.map(({ title, path, visible }) => ({
        title,
        path,
        visible
    })),
    ['/configure']: configureTiles.map(({ title, path, visible }) => {
        return (
        {
        title,
        path,
        visible
    })
}),
    ['/settings']: settingsTiles.map(({ title, path }) => ({
        title,
        path
    })),
    ['/subscriptions']: subscriptionsTiles.map(({ title, path, visible }) => ({
        title,
        path,
        visible
    })),
    ['/support-training']: supportTrainingTiles.map(({ title, path, visible, onClick }) => ({
        title,
        path,
        visible,
        onClick
    })),
    ['/reports']: reportsTiles.map(({ title, path, visible }) => ({
        title,
        path,
        visible
    })),
    ['/configure/integrations']: integrationsSubTiles.map(({ title, path, visible }) => (
        {
        title,
        path,
        visible
    })),
    ['/configure/permissions']: permissionsConfig.map(({ title, path, visible }) => ({
        title,
        path,
        visible
    })),
    ['/configure/branding']: brandingTiles.map(({ title, path, visible }) => ({
        title,
        path,
        visible
    })),
    ['/configure/security']: securityTiles.map(({ title, path, visible }) => ({
        title,
        path,
        visible
    })),
    ['/settings/alert-module']: alertModuleConfig.map(({ title, path, visible }) => ({
        title,
        path,
        visible
    }))
};
